export const LEGAL_AFFILIATE_HEADING: string = `

<center>
 <h1 style="margin-bottom: 0">Affiliate Terms</h1>
 Terms and Conditions Overview
</center>

---

## Affiliate Terms

*Also Referred to as “Allgemeine Geschäftsbedingungen (abgekürzt AGB)” in German Law*
*Effective as November 19, 2024, and Last updated November 19, 2024*
`;
